import { useEffect } from 'react'
import { addChipsToAnte, readyToPlay, winnerCombination } from '../contents'

export default function useGenerateText({
  gameState,
  ante,
  text,
  setDelay,
  settext,
  playerWinType,
  currency,
  totalWin,
  isFold,
  precision
}: any) {
  useEffect(() => {
    switch (gameState) {
      case 0:
        if (ante === '0') {
          setDelay(200)
          settext(addChipsToAnte())
        } else {
          if (text.props.children[0] !== 'Ready To ') {
            settext(readyToPlay())
          }
        }
        break
      case 4:
        setDelay(1500)
        settext(
          winnerCombination(
            playerWinType,
            currency,
            gameState,
            totalWin,
            precision
          ),
        )
        break
      case 6:
        if (isFold) {
          if (ante === '0') {
            setDelay(200)
            settext(addChipsToAnte())
          } else {
            if (text.props.children[0] !== 'Ready To ') {
              settext(readyToPlay())
            }
          }
        } else {
          setDelay(800)
          settext(
            winnerCombination(
              playerWinType,
              currency,
              gameState,
              totalWin,
              precision
            ),
          )
        }
        break

      case 5:
      case 11:
      case 15:
        setDelay(800)
        settext(
          winnerCombination(
            playerWinType,
            currency,
            gameState,
            totalWin,
            precision
          ),
        )
        break
      case 14:
        setDelay(1200)
        settext(
          winnerCombination(
            playerWinType,
            currency,
            gameState,
            totalWin,
            precision
          ),
        )
        break
      default:
        break
    }
  }, [gameState, isFold, playerWinType])

  useEffect(() => {
    if (ante === '0') {
      setDelay(200)
      settext(addChipsToAnte())
    } else {
      if (text.props.children[0] !== 'Ready To ') {
        settext(readyToPlay())
      }
    }
  }, [ante])
}
